import { useEffect, useState } from 'react'

import { fetchHighlightSeriesList } from '../data'

export const useHighlightSeriesList = ({ status = 'UNKNOWN', pageParam = 1 }) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [highlightSeriesList, setHighlightSeriesList] = useState(null)

    const fetchEventSchedulerData = async () => {
        try {
            setLoading(true)
            const response = await fetchHighlightSeriesList({ pageParam })

            setHighlightSeriesList(response.data)
            setData(response)
        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const refetch = () => {
        fetchEventSchedulerData()
    }

    useEffect(() => {
        fetchEventSchedulerData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, pageParam])

    return { data, highlightSeriesList, loading, error, refetch }
}
